<template>
  <div class="dropzone dropzone-queue mb-2" :id="valueId">
    <div class="dropzone-panel mb-lg-0 mb-2">
      <button type="button" class="dropzone-select btn btn-sm me-2" :disabled="isDisabled || files?.length >= number" :class="btnClass">{{$t('attach_file')}}</button>
      <button class="dropzone-remove-all btn btn-sm" :disabled="isDisabled || files?.length >= number" :class="btnClass">{{$t('remove_all')}}</button>
    </div>
    <span class="form-text text-muted mt-2" v-if="showText">{{$t('upload_text', { size: size+'Mo',number: number, ext: 'PDF, DOC, DOCX, JPEG, PNG et JPG' })}}</span>
    <div class="dropzone-items wm-200px" v-show="showAddFiles">
      <div class="dropzone-item " style="display:none">
        <div class="dropzone-file">
          <div class="dropzone-filename">
            <span class="d-flex align-items-center" data-dz-name></span>
          </div>

          <div class="dropzone-error" data-dz-errormessage></div>
        </div>
        <div class="dropzone-progress">
          <div class="progress">
            <div
                class="progress-bar bg-primary"
                role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" data-dz-uploadprogress>
            </div>
          </div>
        </div>
        <div class="dropzone-toolbar">
          <span class="dropzone-delete" data-dz-remove><i class="bi bi-x fs-1"></i></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref, watch, shallowRef, inject} from "vue";
import {getFileIcon} from "@/mixins/Helpers";

const props = defineProps({
  id: String,
  size: String,
  btnClass: {
    type: String,
    default: "btn-primary"
  },
  isDisabled: {
    type: Boolean,
    default: false
  },
  showAddFiles: {
    type: Boolean,
    default: true
  },
  showText: {
    type: Boolean,
    default: true
  },
  number: {
    type: Number,
    default: 10
  }
})

const emitter = inject('emitter')

const files = defineModel()

const valueId = ref(props.id)
const myDropzone = shallowRef(null)

const emits = defineEmits(['remove','saveFiles'])

onMounted(() => {
  dropzone()
  emitter?.on('removeFileOnDropZone', handleRemoveFileOnDropZone)
})

watch(() => files.value, (value) => {
  if(!value || !value?.length){
    myDropzone.value.removeAllFiles(true)
  }
},)

function dropzone(){
  const idValue = "#"+valueId.value;
  let choosenFiles = []
  if(idValue){
    const dropzone = document.querySelector(idValue);
    let previewNode = dropzone?.querySelector(".dropzone-item");
    if(previewNode) {
      previewNode.id = "";
      let previewTemplate = previewNode.parentNode.innerHTML;
      previewNode.parentNode.removeChild(previewNode);

      myDropzone.value = new Dropzone(idValue, {
        url: '/',
        autoProcessQueue: false,
        parallelUploads: 20,
        maxFilesize: props.size,
        maxFiles: props.number,
        previewTemplate: previewTemplate,
        previewsContainer: idValue + " .dropzone-items",
        clickable: idValue + " .dropzone-select"
      });


      myDropzone.value.on("addedfile", function (file) {
        choosenFiles.push(file);
        files.value = [...choosenFiles];

        if(!props.showAddFiles){
          emits('saveFiles');
        }

        const filenameContainer = file.previewElement.querySelector('[data-dz-name]');
        if(filenameContainer){
          filenameContainer.innerHTML = getFileIcon(file.name, {type: 'i', size: '2.4em', className: 'me-2'}) + ' ' + file.name;
        }

        file.previewElement.style.display = '';
      });


      myDropzone.value.on("removedfile", (file) => {
        choosenFiles = choosenFiles.filter(arrayFile => arrayFile !== file)
        emits('remove', file)
        files.value = [...choosenFiles]

        if(myDropzone.value.files.length < 1){
          $(idValue + " .dropzone-upload, " + idValue + " .dropzone-remove-all").css('display', 'none');
        }
      });

      myDropzone.value.on("complete", function(file) {
        myDropzone.value.removeAllFiles(true)
      });
    }

  }
}

function upgradeFiles(){
  files.value.forEach(fileData => {
    const mockFile = { name: fileData.name, size: fileData.size || 0, url: fileData.url, type: fileData.type, id:fileData?.id };
    const crossOrigin = "Anonymous"
    myDropzone.value.displayExistingFile(mockFile,fileData.url, null,crossOrigin );
  });
}

function handleRemoveFileOnDropZone(){
  myDropzone.value.removeAllFiles(true)
  files.value = []
}

</script>

<style scoped>
.btn_class{
  border-radius: '8px';
}
</style>
